module.exports = __webpack_public_path__ + "static/liking-disliking-d05fd7299d40ce83b2d2e84685890310.jpg";